import { render, staticRenderFns } from "./EntityTypeSelector.vue?vue&type=template&id=07828f71&scoped=true"
import script from "./EntityTypeSelector.vue?vue&type=script&lang=js"
export * from "./EntityTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./EntityTypeSelector.vue?vue&type=style&index=0&id=07828f71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07828f71",
  null
  
)

export default component.exports